module.exports = __webpack_public_path__ + "static/js/3.8b1c6d39.chunk.worker.js"